import { makeStyles } from '@eagleview/ev-comp-library';

/**
 * Styling associated Success component
 */
export default makeStyles({
  container: {
    display: 'flex',
    width: '100%',
    padding: '16px 24px',
    '@media (max-width:675px)': {
      padding: '16px 24px',
      background: '#FFF',
    },
    alignItems: 'flex-start',
    gap: '16px',
    flex: '1 0 0',
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: '1 0 0',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: '#FFF',
    '@media (max-width:675px)': {
      boxShadow: 'none',
    },
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.12), 0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
  },
  content: {
    display: 'flex',
    padding: '84px 24px',
    '@media (max-width:675px)': {
      padding: '0px',
    },
    '@media (min-width:1024px)': {
      padding: '84px 300px',
    },
    alignItems: 'center',
    flexDirection: 'column',
    gap: '16px',
    alignSelf: 'stretch',
  },
  successHeader: {
    color: '#005A8D',
    fontFamily: 'Noto Sans',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '54px',
    '@media (max-width:675px)': {
      fontSize: '28px',
      lineHeight: '42px',
    },
    textTransform: 'none',
  },
  text: {
    color: '#222',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px', /* 150% */
  },
  emailText: {
    color: '#222',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
  },
  topContainer: {
    position: 'relative',
    minHeight: '90%',
    flex: 1,
    '@media (max-width:675px)': {
      height: 'fit-content',
      flexGrow: 1,
    },
  },
  formMainContainer: {
    display: 'flex',
    width: '509px',
    padding: '24px 0px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    alignSelf: 'stretch',
    '@media (max-width:675px)': {
      width: '100%',
      padding: '0px',
      gap: '0px',
      flexGrow: 1,
      alignSelf: 'stretch',
    },
    position: 'relative',
    overflow: 'auto',
    background: '#FFF',
  },
  evLogoContainer: {
    display: 'flex',
    padding: '16px 48px',
    '@media (max-width:675px)': {
      padding: '24px',
    },
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    alignSelf: 'stretch',
  },
  logo: {
    width: '239px',
    height: 'auto',
    '@media (min-width:675px) and (max-width:1024px)': {
      display: 'flex',
      alignItems: 'center',
    },
    '@media (max-width:675px)': {
      width: '152px',
    },
  },
  formContainer: {
    display: 'flex',
    padding: '24px 48px 0px 48px',
    '@media (max-width:675px)': { padding: '24px' },
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '48px',
    alignSelf: 'stretch',
    borderTop: '1px solid #C8CDD7',
  },
  button: {
    '@media (max-width:675px)': {
      width: '100%',
    },
    textTransform: 'none',
    shadow: 'none',
    boxShadow: 'none',
  },
  noteText: {
    color: '#222',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px', /* 150% */
  },
});
